import axiosInstance from './axiosInstance';

export const downloadLogsApi = {
  // 获取下载日志列表
  getDownloadLogs: async (params) => {
    try {
      const response = await axiosInstance.get('/download-logs/', { params });
      // 对响应进行验证
      if (!response || response.code !== 0) {
        throw new Error(response?.message || '获取下载日志失败，响应格式不正确');
      }
      return response;
    } catch (error) {
      console.error('获取下载日志错误:', error);
      throw new Error(error.message || '获取下载日志失败');
    }
  },
  
  // 创建下载日志
  createDownloadLog: async (data) => {
    try {
      // 确保所有必需字段都存在并且格式正确
      const formattedData = {
        task_id: Number(data.task_id),
        task_name: String(data.task_name),
        user_id: Number(data.user_id),
        user_name: String(data.fullname || data.user_name), // 优先使用fullname
        status: Number(data.status),
        error_message: data.error_message || null
      };
      
      const response = await axiosInstance.post('/download-logs/', formattedData);
      // 对响应进行验证
      if (!response || response.code !== 0) {
        throw new Error(response?.message || '创建下载日志失败，响应格式不正确');
      }
      return response;
    } catch (error) {
      console.error('创建下载日志错误:', error);
      throw new Error(error.message || '创建下载日志失败');
    }
  }
}; 